<template>
  <div
    v-if="osVersionPatchList"
    :class="$style.osReleasePatchContainer"
  >
    <HeadingExtraSmall v-if="showTitle">
      Release Trains
    </HeadingExtraSmall>
    <TabBar v-if="showTabs">
      <template v-slot:tabs>
        <Tabs
          :activeTab="activeTab"
          :tabs="tabs"
          @selectedTab="handleTabSelected"
        />
      </template>
      <TooltipIcon
        v-if="isUbuntuTabSelected"
        :class="$style.tooltip"
        icon="info"
        orientation="left"
        text="Only Ubuntu release information is available at this time."
      />
    </TabBar>
    <OsReleasePatch
      :osName="selectedTab.label"
      :osReleases="selectedOsRelease"
    />
  </div>
</template>

<script>
import {
  HeadingExtraSmall, TabBar, Tabs, TooltipIcon, Types,
} from '@jumpcloud/ui-components';
import { mapActions, mapState } from 'vuex';
import OsReleasePatch from 'client/OsManagement/OsReleasePatch/OsReleasePatch';

const { TabItem } = Types;

export default {
  name: 'OsReleasePatchTabs',

  components: {
    HeadingExtraSmall,
    OsReleasePatch,
    TabBar,
    Tabs,
    TooltipIcon,
  },

  props: {
    showTabs: {
      type: Boolean,
      default: true,
    },
    showTitle: {
      type: Boolean,
      default: false,
    },
    tabSelected: {
      type: String,
      default: '',
    },
  },

  data: () => ({
    tabs: [
      TabItem({
        key: 'MacOS',
        label: 'MacOS',
      }),
      TabItem({
        key: 'Windows',
        label: 'Windows',
      }),
    ],
    activeTab: '',
  }),

  computed: {
    ...mapState('OsReleasesPatchesModule', ['osVersionPatchList']),

    isUbuntuTabSelected() {
      return this.activeTab === 'Ubuntu';
    },

    selectedOsRelease() {
      if (!this.osVersionPatchList) return [];
      return this.osVersionPatchList[this.activeTab];
    },

    selectedTab() {
      return this.tabs.find(({ key }) => key === this.activeTab);
    },
  },

  watch: {
    tabSelected() {
      if (this.tabSelected.length === 0) {
        this.activeTab = this.tabs[0].key;
      } else {
        this.activeTab = this.tabSelected === 'Linux' ? 'Ubuntu' : this.tabSelected;
      }
    },
  },

  async created() {
    this.activeTab = this.tabSelected === 'Linux' ? 'Ubuntu' : this.tabSelected || this.tabs[0].key;

    this.tabs.push(TabItem({
      key: 'Ubuntu',
      label: 'Ubuntu',
    }));

    if (this.osVersionPatchList.length === 0) {
      await this.fetchOsReleases();
    }
  },

  methods: {
    ...mapActions('OsReleasesPatchesModule', ['fetchOsReleases']),

    handleTabSelected(tabKey) {
      const newSelectedTab = this.tabs.find((tab) => tab.key === tabKey);
      this.activeTab = newSelectedTab.key;
    },
  },
};
</script>
<style module scoped>
.osReleasePatchContainer {
  width: 100%;
}

.tooltip {
  z-index: 3;
}
</style>
